import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

if(process.client){
    Vue.use( CKEditor );
}
